import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const NoStoresPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.noStores,
      component: React.lazy(() => import('app/main/pages/noStores/NoStoresPage')),
    },
  ],
};

export default NoStoresPageConfig;
